export enum AccountSettingsTab {
  PROFILE = 'profile',
  LANGUAGE = 'language',
  PASSWORD = 'password',
  TIMEZONE = 'timezone',
  NOTIFICATION = 'notification',
}
